/** Shared timing for right-rail stack expand/collapse (matches `--rail-stack-duration`). */
export const RAIL_STACK_DURATION_MS = 480;
